import type { BroadcastPlacement } from '@noorview/core';
import { PLACEMENTS } from '@noorview/core';

/**
 * Where a message or appeal shows, picked from small pictures of the screen (like choosing a template). The extra
 * option shows it in place of a widget: one chosen widget, or the screen's announcement or donation widgets.
 */
export function PositionPicker({ value, onChange, widget, only }: {
  value: BroadcastPlacement;
  onChange: (v: BroadcastPlacement) => void;
  /** The widget option: its label and, when it's one particular widget, where that widget sits (fractions of the screen). */
  widget?: { label: string; box?: [number, number, number, number] };
  /** Limit the choices (e.g. appeals don't use the bands). */
  only?: BroadcastPlacement[];
}) {
  const options = PLACEMENTS.filter((p) => !only || only.includes(p.value));
  const tile = (key: BroadcastPlacement, label: string, box: [number, number, number, number] | null, many = false) => (
    <button key={key} type="button" role="radio" aria-checked={value === key} className={`pos-opt${value === key ? ' on' : ''}`} onClick={() => onChange(key)}>
      <span className="pos-screen" aria-hidden>
        {box ? <i style={{ left: `${box[0] * 100}%`, top: `${box[1] * 100}%`, width: `${box[2] * 100}%`, height: `${box[3] * 100}%` }} />
          : many ? <><i className="w" style={{ left: '6%', top: '10%', width: '40%', height: '36%' }} /><i className="w" style={{ left: '54%', top: '54%', width: '40%', height: '36%' }} /></> : null}
      </span>
      <span className="pos-name">{label}</span>
    </button>
  );
  return (
    <div className="pos-picker" role="radiogroup" aria-label="Where it shows">
      {widget && tile('widget', widget.label, widget.box ?? null, !widget.box)}
      {options.map((p) => tile(p.value, p.label, p.box))}
    </div>
  );
}
